<template>
    <div class="ht-dialog"
         v-if="dialogVisible"
         ref="dialog">
        <div class="ht-dialog-shade"
             @click="except"></div>
        <div class="ht-dialog-content"
             :style="{loadingDialog,top:top+'%',width:width,'box-shadow':loadingDialog?'':'0 1px 3px rgba(0,0,0,0.3)',background:loadingDialog?'':'#fff'}"
             ref="dialogContent">
            <div class="ht-dialog-content-title"
                 v-if="title && !loading">
                <label>{{title}}</label><i @click="handleClose(true,handleCloseFun)"
                   class="iconfont icondanchuangguanbiicon"></i>
            </div>
            <el-scrollbar wrap-class="default-scrollbar__wrap"
                          view-class="p4-scrollbar__view"
                          class="default-scrollbar dialogContent"
                          :style="{opacity:!loading?1:0}"
                          ref="scrollbar">
                <div class="ht-dialog-content-interaction"
                     :style="{width:width}"
                     ref="interaction">
                    <slot></slot>
                    <slot name="interaction"></slot>
                </div>
            </el-scrollbar>
            <div class="ht-dialog-content-footer"
                 v-if="!loading&&(cancel||affirm)">
                <button class="ht-dialog-content-footer-cleansing"
                        v-if="cancel"
                        @click="boxCancel">{{cancel}}</button>
                <button class="ht-dialog-content-footer-pollute"
                        v-if="affirm"
                        @click="boxAffirm">{{affirm}}</button>
            </div>
            <ht-loading :loading="loading"
                        limi
                        dialog
                        style="height: 1rem;"
                        :name="'loading'"></ht-loading>
        </div>
    </div>
</template>
<script>
import htLoading from 'base/ht-loading'// loading
export default {
    components: { htLoading },
    props: {
        dialogVisible: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: ''
        },
        cancel: {// 取消
            type: String,
            default: ''
        },
        affirm: { // 确认
            type: String,
            default: ''
        },
        top: { // 内容居上高度
            type: Number,
            default: 10
        },
        boxExceptPd: { // 区域以外点击
            type: Boolean,
            default: false
        },
        width: { // 内容宽度
            type: String,
            default: '4rem'
        },
        loadingDialog: { // loadingDialog状态
            type: Boolean,
            default: false
        },
        handleCloseFun: {
            type: Function
        }
    },
    data () {
        return {
            loading: false
        }
    },
    mounted () {

    },
    methods: {
        /**
         * @description:
         * @param {*} judge
         * @param {*} handleCloseFun 关闭X按钮时还有其他指令回调方法
         * @return {*}
         */
        handleClose (judge, handleCloseFun) { // 关闭
            if (typeof handleCloseFun === 'function') {
                handleCloseFun()
                return
            }
            if (this.$refs.dialogContent) {
                this.$refs.dialogContent.style['margin-top'] = '-10px'
                this.$refs.dialogContent.style.opacity = 0
            }
            setTimeout(() => {
                this.$emit('update:dialogVisible', false)
                this.$emit('update:loadingDialog', false)
                if (judge) this.$emit('boxHandleClose') // 点击X关闭操作
            }, 200)
        },
        boxCancel () {
            this.$emit('boxCancel', this.cancel, val => {
                if (!val) this.handleClose()
            })
        },
        boxAffirm () {
            this.$emit('boxAffirm', this.affirm, val => {
                if (!val) this.handleClose()
            })
        },
        except () { // 区域以外事件
            // setTimeout(() => {
            //     this.$emit('boxExceptClose') // 区域以外操作回调
            // }, 200)
            // if (!this.boxExceptPd) this.handleClose()
        }
    },
    watch: {
        $route (to, from) { // 跳转页面 关闭
            this.handleClose()
        },
        dialogVisible (val) {
            setTimeout(() => {
                if (val && this.$refs.dialogContent) {
                    this.$refs.dialogContent.style['margin-top'] = '0px'
                    this.$refs.dialogContent.style.opacity = 1
                }
            }, 30)
        },
        loadingDialog (val) {
            this.loading = val
        }
    }
}
</script>
<style  lang="stylus" rel='stylesheet/stylus'>
// @import '~common/stylus/variable';
.ht-dialog {
    position: fixed
    top: 0
    right: 0
    bottom: 0
    left: 0
    overflow: auto
    margin: 0
    z-index: 2002
    font-size: 0.2rem
    overflow-x: hidden
    text-align: center
    .is-horizontal {
        display: none
    }
    .el-scrollbar__bar.is-vertical {
        z-index: 2001
    }
    .el-scrollbar__wrap.default-scrollbar__wrap {
        overflow-x: hidden !important
        max-height: 7rem
    }
    &-shade {
        position: fixed
        left: 0
        top: 0
        width: 100%
        height: 100%
        opacity: 0.5
        background: #000
        z-index: 2001
    }
    &-content {
        text-align: left
        position: relative
        margin: 0 auto
        box-sizing: border-box
        z-index: 2003
        transition: margin-top 0.3s, opacity 0.3s
        opacity: 0
        margin-top: -10px
        display: inline-block
        .dialogContent {
        }
        // padding: 0.19rem 0.24rem;
        &-title {
            display: flex
            // align-items: center;
            // height: 0.56rem;
            // line-height: 0.56rem;
            padding: 0 0.24rem
            box-sizing: border-box
            align-items: end
            padding: 0.1rem 0.2rem
            border-bottom: 1px solid #E6E6E6
            label {
                font-size: 0.18rem
                font-weight: bold
                color: #333
                flex: 1
                float: left
                line-height: 1.2
                overflow: hidden
                display: -webkit-box
                -webkit-line-clamp: 3
                -webkit-box-orient: vertical
                margin-right: 0.2rem
            }
            i {
                color: #9BA9B5
                cursor: pointer
                float: right
                &:hover {
                    color: #2396F5
                }
            }
        }
        &-interaction {
            // padding: 0.24rem 0;
            box-sizing: border-box
            margin-bottom: 4px
            // max-height: 600px;
        }
        &-footer {
            display: flex
            align-items: center
            height: 0.56rem
            background-color: #F2F7F7
            line-height: 0.56rem
            padding: 0 0.24rem
            justify-content: flex-end
            border-top: 1px solid #E6E6E6
            &-cleansing {
                color: #62696F
                background-color: #fff
                border: 1px solid #DBDBDB
            }
            &-pollute {
                background-color: #2396F5
                color: #fff
                border: none
            }
            button {
                height: 0.32rem
                line-height: 0.32rem
                padding: 0 0.18rem
                font-size: 0.14rem
                box-sizing: border-box
                margin-left: 0.16rem
                cursor: pointer
                border-radius: 2px
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/base/ht-dialog.vue